import { ANALYTICS_TYPES } from '@/Common/Runtime/events';
import { IAnalyticsAdapter } from '@/HostApp/types/AnalyticsModule';
import GoogleAnalyticsAdapter from './Adapters/GoogleAnalyticsAdapter';

export class AnalyticsModule {
	private getAnalyticsAdapter(type?: string): IAnalyticsAdapter {
		let adapter: IAnalyticsAdapter;

		switch (type) {
			case ANALYTICS_TYPES.GOOGLE_ANALYTICS:
				adapter = GoogleAnalyticsAdapter.getInstance();
				break;
			default:
				adapter = GoogleAnalyticsAdapter.getInstance();
		}

		return adapter;
	}

	public pushData(eventData: Analytics.ITypedData): void {
		if (!eventData.data) {
			// eslint-disable-next-line no-console
			console.warn(`There is no event data!`);
			return;
		}

		this.getAnalyticsAdapter(eventData.analyticsType)?.pushData(eventData.data);
	}

	public pushHostGAData(eventData: { event: string; eventCategory: string; eventAction: string }): void {
		const context = window.aps.context;
		const viewId: string = context._view.id;

		this.pushData({
			analyticsType: ANALYTICS_TYPES.GOOGLE_ANALYTICS,
			data: {
				...eventData,
				eventLabel: viewId ? viewId.substring(viewId.indexOf('#') + 1) : 'aps is not loaded yet',
				dimension3: 'userId' in context.user ? String(context.user.userId) : ''
			}
		});
	}

	public pushException(viewId: string, viewLabel: string, message: string, type?: string): void {
		if (!message) {
			// eslint-disable-next-line no-console
			console.warn(`There is no exception message!`);
			return;
		}

		this.getAnalyticsAdapter(type)?.pushException(viewId, viewLabel, message);
	}
}

const analyticsModule = new AnalyticsModule();

export default analyticsModule;
